import { FormHeader } from '@snsw/react-component-library';
import { getStepListContent, getActiveStepListTitle } from './stepsListContent';
import styled from 'styled-components';
import { useApplicationConfig } from '../../../store';
import React from 'react';

const FormHeaderWrapper = styled.div`
    margin-bottom: -3.5rem;
`;

export const HeaderStepper = (props: any) => {
    const { Step } = props;
    const config = useApplicationConfig();
    const StepsLabel = ['Personal details', 'Eligibility', 'Supporting documents', 'Bank details', 'Review'];

    return (
        <FormHeaderWrapper>
            <FormHeader
                label={ config.appTitle }
                stepsList={ getStepListContent(StepsLabel, Step ? Step : 0) }
                title={ getActiveStepListTitle() }
            />
        </FormHeaderWrapper>
    );
};

export default HeaderStepper;
